<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="requiredOneTrue" type="checkbox" value="{{fieldOptions.validate.requiredOneTrue}}"
           [(ngModel)]="fieldOptions.validate.requiredOneTrue">
    <span><b>At least one true value is required</b></span>
  </label>
</div>